import { Component } from "react";

class Loading extends Component {
  render() {
    return <span className="sr-only">Loading...</span>;
  }
}

export default Loading;
